
import api from './api'
import { useDownload } from '@/helpers/download'

export default {    
    
    count(params = {}) {

        return api.get('/factures', { params })
            .then( response => parseInt(response.headers['x-pagination-count']) )
    },

    get(id) {

        return api.get('/factures/' + id, {})
            .then( json => {

                let facture = json.data

                return facture
            })
            
    },

    getDocuments(id, ligneNums) {

        return new Promise((resolve, reject) => {

            api.post('/factures/' + id + '/documents/file', { lignes: ligneNums })
                .then( response => {
                    if ( response.status === 204 ) {
                        reject('Aucun document à télécharger') 
                    }

                    useDownload(response.headers.location)
                        .then(() => resolve() )
                })
                .catch(() => reject())                
        })
    },

    getFile(id) {
        
        return new Promise((resolve, reject) => {

            api.post('/factures/' + id + '/file', {})
                .then( response => {
                    if ( response.status === 204 ) {
                        reject('Aucun document à télécharger') 
                    }

                    useDownload(response.headers.location)
                        .then(() => resolve() )
                })
                .catch(() => reject())
            })
            
    },

    getXlsx(params = {}) {

        return new Promise((resolve, reject) => {

            api.post('/factures/file', null, { params: params })
                .then( response => {
                    if ( response.status === 204 ) {
                        reject('Aucun fichier à télécharger') 
                    }

                    useDownload(response.headers.location)
                        .then(() => resolve() )
                })
                .catch(() => reject())
        }) 
    },    

    list(params = {}) {

        return api.get('/factures', { params })
            .then( json => json.data )
            
    },

    search(params = {}) {

        return api.get('/factures', { params })
            .then( json => json.data )            
    } 
}
